// extracted by mini-css-extract-plugin
module.exports = {"errorPane":"ErrorPane_errorPane__AFOZn"};